import React from 'react'
import curated from '../../../assets/images/curated-exp.svg'
import exclusive from '../../../assets/images/exclusive-img.svg'
import planning from '../../../assets/images/planning.svg'
import solofriendly from '../../../assets/images/solo-friendly.svg'
import localevents from '../../../assets/images/local-events.svg'

export default function FithSection() {
    return (
        <section className="section-equal-padding choose_my_siffiVacation">
            <div className="container-fluid">
                <div className="section-top-heading" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false ">
                    <h2 className="mb-3 text-black text-center">Why choose MySiffiVacation for <br />
                        your solojourney to Austin?</h2>
                </div>
                <div className="row gy-4 mt-3">
                    <div className="col-md-6 col-lg-4">
                        <div className="mysiffiVacation_box"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="curated_experiences_heading">
                                <h3> <img src={curated} alt="curated" loading='lazy' width="48" height="48" /> Curated
                                    Experiences</h3>
                                <h2>01</h2>
                            </div>
                            <p>
                                MySittiVacation helps you plan a personalized solo trip to Atlanta—explore the Martin Luther
                                King Jr. National Historic Site, enjoy the High Museum of Art, and taste diverse Southern
                                cuisine for an unforgettable experience.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="mysiffiVacation_box"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="curated_experiences_heading">
                                <h3> <img src={exclusive} alt="exclusive" loading='lazy' width="48" height="48" />Exclusive
                                    Deals
                                </h3>
                                <h2>02</h2>
                            </div>
                            <p>Benefit from exclusive offers from MySittiVacation on tickets, tours, and local experiences
                                in Atlanta. Our partnerships with top vendors ensure you receive the best rates, making your
                                travel experience both enjoyable and budget-friendly.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="mysiffiVacation_box"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="curated_experiences_heading">
                                <h3> <img src={planning} alt="planning" loading='lazy' width="48" height="48" />Ease of Planning
                                </h3>
                                <h2>03</h2>
                            </div>
                            <p>
                                Your safety is our priority. MySittiVacation provides clear guidance to help you navigate
                                Atlanta with confidence—from safe neighbourhoods and dependable transport to practical local
                                tips—ensuring a smooth, enjoyable solo trip.</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mysiffiVacation_box"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="curated_experiences_heading">
                                <h3> <img src={solofriendly} alt="solofriendly" loading='lazy' width="48" height="48" />Solo-Friendly
                                    Travel Tips </h3>
                                <h2>04</h2>
                            </div>
                            <p>For solo travelers seeking adventure and relaxation, MySittiVacation makes planning your
                                Atlanta trip easy—enjoy Piedmont Park, visit the Georgia Aquarium, and explore vibrant spots
                                like Little Five Points with comfort and confidence.</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mysiffiVacation_box"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <div className="curated_experiences_heading">
                                <h3> <img src={localevents} alt="localevents" loading='lazy' width="48" height="48" />Local Events
                                    and
                                    Entertainment</h3>
                                <h2>05</h2>
                            </div>
                            <p>Discover a range of solo-friendly accommodations in Atlanta with MySittiVacation. Whether you
                                prefer a chic downtown hotel or a cozy retreat in Midtown, our platform highlights options
                                that offer comfort, safety, and opportunities to connect with fellow travelers.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
